export function subscribeToStore(store, observers = []) {
    const unsubscribes = [];
    observers.forEach(observer => {
        unsubscribes.push(observer(store));
    });

    return () => unsubscribeFromStore(unsubscribes);
}

export function unsubscribeFromStore(unsubscribes = []) {
    unsubscribes.map((unsubscribe) => unsubscribe());
}



// WEBPACK FOOTER //
// ./app/lib/observe/index.js